var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.94762C0 4.27456 0.265699 4.5397 0.593349 4.5397H9.51143L7.2865 6.89559C7.05128 7.11543 7.04425 7.53996 7.28043 7.75898C7.52006 7.98129 7.93131 7.90187 8.14568 7.7097L11.3101 4.35485C11.4071 4.25202 11.4653 4.08889 11.4708 3.94779C11.4708 3.79031 11.4184 3.65554 11.3101 3.54073L8.14568 0.185877C7.93999 -0.0141401 7.51411 -0.0848961 7.28043 0.136597C7.04673 0.358089 7.08412 0.797636 7.2865 0.999986L9.51143 3.35559L0.592996 3.35559C0.265356 3.35559 0 3.62054 0 3.94762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverArrow);
export default __webpack_public_path__ + "static/media/discover-arrow.e3a9fcb651fa0e065375eac4e71c5638.svg";
export { ForwardRef as ReactComponent };